export default __webpack_public_path__ + "static/media/status_unknown.8b4d7b96.svg";